import React from 'react';
import { branch } from 'baobab-react/higher-order';
import { Link } from 'react-router';

class ReplacementProcessCallouts extends React.Component {

	handleClick(e) {
		global.dataLayer.push({
			event: 'Replacement Links',
			eventCategory: 'Support',
			eventAction: e.currentTarget.textContent,
			eventLabel: global.location.pathname
		});
	}

	render() {
		const model = this.props.model;
		return (
			<div className="lost-key-combo">
				<div className="replacement-process-callouts">
					<div className="row">
						<div className="col sm-4">
							<Link
								className="replacement-process-callout"
								to={model.lostKeyUrl}
								target="_blank"
								onClick={ e => this.handleClick(e) }
							>
								<img
									src={ require('../../../resources/img/icons/key-icon.png') }
									srcSet={ `${require('../../../resources/img/icons/key-icon@2x.png')} 2x` }
									alt="Key"
								/>
								<p className="arrow-link">
									Key Replacement Process
								</p>
							</Link>
						</div>
						<div className="col sm-4">
							<Link
								className="replacement-process-callout"
								to={model.lostComboUrl}
								target="_blank"
								onClick={ e => this.handleClick(e) }
							>
								<img
									src={ require('../../../resources/img/icons/combo-icon.png') }
									srcSet={ `${require('../../../resources/img/icons/combo-icon@2x.png')} 2x` }
									alt="Combo"
								/>
								<p className="arrow-link">
									Combo Replacement Process
								</p>
							</Link>
						</div>
						<div className="col sm-4">
							<Link
								className="replacement-process-callout"
								to={model.lostKeyComboUrl}
								target="_blank"
								onClick={ e => this.handleClick(e) }
							>
								<div>
									<img
										src={ require('../../../resources/img/icons/key-icon.png') }
										srcSet={ `${require('../../../resources/img/icons/key-icon@2x.png')} 2x` }
										alt="Key"
									/>
									<img
										src={ require('../../../resources/img/icons/combo-icon.png') }
										srcSet={ `${require('../../../resources/img/icons/combo-icon@2x.png')} 2x` }
										alt="Combo"
									/>
								</div>
								<p className="arrow-link">
									Key &amp; Combo Replacement Process
								</p>
							</Link>
						</div>
					</div>
				</div>
			</div>
		);
	}
};
export default branch({
	model: ['model']
}, ReplacementProcessCallouts);


// WEBPACK FOOTER //
// ./src/pages/support/lostKeyCombo/ReplacementProcessCallouts.js